import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  InputBase,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import { rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseCustomerRetention } from "./UseCustomerRetention";
import DeleteRow from "../../components/DeleteRow";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { useLocation, useNavigate } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

export default function PatternsGrid(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [patternRes, setPatternRes] = useState();
  const { GetPatternsList, deletePattern } = UseCustomerRetention();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("Patterns");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetPatternsList(
      myPc,
      search,
      (patterns) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(patterns.pageCondition.totalPage);
          return;
        }
        props.setPatterns(patterns.items);
        setPatternRes(patterns);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/customerretention/addPattern", {
      state: { myPc: myPc, search: search, expanded: props.expanded },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 250,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "shamsiDate",
      headerName: "تاریخ",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate(`/customerretention/editPattern`, {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      id="Patterns"
      expanded={props.expanded === "Patterns"}
      onChange={handleChange("Patterns")}
      style={{
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            الگوها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          {patternRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={patternRes.pageCondition.pageCount}
              rows={patternRes.items}
              paginationMode="server"
              page={patternRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                patternRes?.pageCondition.totalItemCount
                  ? patternRes.pageCondition.totalItemCount
                  : 0
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{ Pagination: CustomPagination }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  newFunc: newFunc,
                  isLtr: true,
                  rowCount: patternRes?.pageCondition.totalItemCount
                    ? patternRes.pageCondition.totalItemCount
                    : 0,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: { page: myPc.page },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
          <DeleteRow
            deleteState={deleteState}
            setDeleteState={setDeleteState}
            type={"الگو"}
            callback={() => {
              setProgress(true);
              deletePattern(deleteState.id, () => {
                refresh();
              });
            }}
          ></DeleteRow>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
